export class ContatoreAttiVO {
	attiBozzaRevisione: number;
	attiVerifica: number;
	attiApprovati: number;
	attiInFirma: number;
	attiFirmati: number;
	attiPubblicati: number;
	attiVerificaContabile: number;
	attiVistoContabile: number;
	attiRifiutoContabile: number;
	attiApprovatiCollegio: number;
	attiOsservati: number;
	attiApprovatiNotificare: number;
	attiAnnullati: number;
	attiRitirati: number;
}